import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import BioStats from './components/BioStats';
import CareerHighlights from './components/CareerHighlights';
import News from './components/News';
import Merchandise from './components/Merchandise';
import TipsAndTricks from './components/TipsAndTricks';
import Footer from './components/Footer';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  const [cartCount, setCartCount] = useState(0);

  useSEO({
    title: 'Zane Nightmare Morehouse | Professional Baseball Pitcher & Merchandise',
    description: 'Official website of Zane Nightmare Morehouse, professional baseball pitcher. Shop exclusive Nightmare Collection merchandise, read latest news, and get expert baseball tips from a pro athlete.',
    keywords: 'Zane Morehouse, Nightmare, professional baseball, pitcher, baseball merchandise, baseball apparel, baseball tips',
    canonical: '/',
    ogType: 'website',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Person',
          '@id': 'https://example.com/#person',
          name: 'Zane Nightmare Morehouse',
          alternateName: 'Nightmare',
          jobTitle: 'Professional Baseball Pitcher',
          description: 'Professional baseball pitcher known for his powerful pitching and competitive spirit',
          url: 'https://example.com/',
          sameAs: []
        },
        {
          '@type': 'WebSite',
          '@id': 'https://example.com/#website',
          url: 'https://example.com/',
          name: 'Zane Nightmare Morehouse',
          description: 'Official website of professional baseball pitcher Zane Nightmare Morehouse',
          publisher: {
            '@id': 'https://example.com/#person'
          }
        },
        {
          '@type': 'WebPage',
          '@id': 'https://example.com/#webpage',
          url: 'https://example.com/',
          name: 'Zane Nightmare Morehouse | Professional Baseball Pitcher & Merchandise',
          isPartOf: {
            '@id': 'https://example.com/#website'
          },
          about: {
            '@id': 'https://example.com/#person'
          },
          description: 'Official website of Zane Nightmare Morehouse, professional baseball pitcher. Shop exclusive Nightmare Collection merchandise, read latest news, and get expert baseball tips.',
          inLanguage: 'en-US'
        },
        {
          '@type': 'Store',
          '@id': 'https://example.com/#store',
          name: 'Nightmare Collection',
          description: 'Official merchandise store featuring exclusive Nightmare Collection apparel and accessories',
          url: 'https://example.com/',
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Nightmare Collection Products',
            itemListElement: [
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Product',
                  name: 'Baseball Merchandise',
                  category: 'Apparel & Accessories'
                }
              }
            ]
          }
        }
      ]
    }
  });

  return (
    <div className="bg-[#0a0a0a] min-h-screen">
      <Navbar cartCount={cartCount} />
      <Hero />
      <div id="bio">
        <BioStats />
      </div>
      <div id="highlights">
        <CareerHighlights />
      </div>
      <div id="news">
        <News />
      </div>
      <div id="merchandise">
        <Merchandise onCartChange={setCartCount} />
      </div>
      <div id="tips">
        <TipsAndTricks />
      </div>
      <Footer />
    </div>
  );
}
